import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomControl.css';
import homeIcon from '../../../assets/baseline-home-24px.svg';
var CustomControl = function CustomControl(props) {
  var map = props.map,
    initialOptions = props.initialOptions,
    language = props.language;
  var classNames = ['CustomControl', props.type];
  var _useState = useState(map.getBearing()),
    compassRotateDeg = _useState[0],
    setCompassRotateDeg = _useState[1];
  var homeTooltip = 'Retour à vue principale';
  if (language === 'en') {
    homeTooltip = 'Return to the initial view';
  }
  var mapInfo = {
    lng: map.getCenter()[0],
    lat: map.getCenter()[1],
    zoom: map.getZoom(),
    pitch: map.getPitch(),
    bearing: map.getBearing()
  };
  useEffect(function () {
    map.on('pitch', function () {
      setCompassRotateDeg(map.getBearing());
    });
  }, []);
  var handleClick = function handleClick() {
    switch (props.type) {
      case 'compass':
        {
          mapInfo.bearing = 0;
          setCompassRotateDeg(0);
          break;
        }
      case 'home':
        {
          mapInfo.center = [initialOptions.lng, initialOptions.lat];
          mapInfo.zoom = initialOptions === null || initialOptions === void 0 ? void 0 : initialOptions.zoom;
          mapInfo.pitch = (initialOptions === null || initialOptions === void 0 ? void 0 : initialOptions.zoom) >= 15 ? initialOptions.pitch : 0;
          mapInfo.bearing = initialOptions.bearing || 0;
          break;
        }
    }
    map.flyTo(mapInfo);
  };
  var handleCompassLeftButtonClick = function handleCompassLeftButtonClick() {
    map.rotateTo(map.getBearing() - 45, {
      duration: 500
    });
    setCompassRotateDeg(function (prevState) {
      return prevState - 45;
    });
  };
  var handleCompassRightButtonClick = function handleCompassRightButtonClick() {
    map.rotateTo(map.getBearing() + 45, {
      duration: 500
    });
    setCompassRotateDeg(function (prevState) {
      return prevState + 45;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames.join(' ')
  }, props.type === 'compass' && /*#__PURE__*/React.createElement("div", {
    className: "bg-overlay-compass"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'btn-compass arrow-left',
    onClick: handleCompassLeftButtonClick
  }), /*#__PURE__*/React.createElement("span", {
    className: 'btn-compass compass-btn',
    onClick: handleClick,
    style: {
      transform: "rotate(" + compassRotateDeg + "deg)"
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: 'btn-compass arrow-right',
    onClick: handleCompassRightButtonClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "bg-overlay",
    onClick: handleClick
  }, props.type === 'home' && /*#__PURE__*/React.createElement("img", {
    src: homeIcon,
    title: homeTooltip,
    alt: ""
  })));
};
CustomControl.propTypes = process.env.NODE_ENV !== "production" ? {
  map: PropTypes.object.isRequired,
  initialOptions: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['compass', 'home']).isRequired,
  language: PropTypes.string
} : {};
export default CustomControl;